import React, { useState, useMemo, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import {
  TextField,
  Button,
  Switch,
  FormControlLabel,
  CircularProgress,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Api from "../../Api/Api.json";
import { useSMSData } from "../../hooks/useSMSData";
import { useSMSData2 } from "../../hooks/useSMSData2";

const SendSMS = ({ patient_id }) => {
  const [showHistory, setShowHistory] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const {
    data: smsData = [],
    isLoading: isSmsLoading,
    isError: isSmsError,
    error: smsError,
  } = useSMSData(patient_id);

  // const {
  //   data,
  //   isLoading,
  //   isError,
  //   error
  // } = useSMSData2(patient_id);

  // console.log(data);

  const containerRef = useRef();
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [smsData, showHistory]);

  const onSubmit = async (data) => {
    const url = Api.DEV_TEST_API;
    const requestData = {
      task: "sendDoctorMessage",
      patient_id: patient_id,
      message: data.message,
    };
    try {
      const response = await axios.post(url, requestData, {
        headers: { "Content-Type": "application/json" },
      });
      if (response.data) {
        reset();
        console.log(response.data);
        toast.success("Message sent successfully!");
      } else {
        toast.error("Error sending message");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error sending message");
    }
  };

  return (
    <div className="card">
      <ToastContainer />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h5" fontWeight={600}>
          {showHistory ? "SMS History" : "Send SMS"}
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={showHistory}
              onChange={() => setShowHistory((prev) => !prev)}
              color="primary"
            />
          }
          label={showHistory ? "Compose Message" : "View History"}
        />
      </Box>

      {showHistory ? (
        isSmsLoading ? (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        ) : isSmsError ? (
          <Typography color="error">{smsError.message}</Typography>
        ) : (
          <Box
            ref={containerRef}
            sx={{
              maxHeight: 450,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 2,
              p: 1,
            }}
          >
            {smsData.map((sms, idx) => {
              const isDoctor = sms.sms_type === "Pregnancy Reply";
              return (
                <Box
                  key={idx}
                  display="flex"
                  justifyContent={isDoctor ? "flex-end" : "flex-start"}
                >
                  <Paper
                    sx={{
                      p: 0.5,
                      borderRadius: 2,
                      maxWidth: "75%",
                      boxShadow: 1,
                      bgcolor: isDoctor ? "#DCF8C6" : "#F1F0F0",
                    }}
                  >
                    {/* <Typography
                      variant="body1"
                      sx={{
                        wordBreak: "break-word",
                        color: isDoctor ? "#0B3D0B" : "#aaaaaa",
                      }}
                    >
                      {sms.sms}
                    </Typography> */}
                    <p style={
                      {
                        wordBreak: "break-word",
                        color: isDoctor ? "#000000" : "#0B3D0B",
                        margin: 0,
                      }}
                    >{sms.sms}</p>
                  </Paper>
                </Box>
              );
            })}
          </Box>
        )
      ) : (
        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
          <TextField
            label="Your Message"
            multiline
            rows={4}
            fullWidth
            margin="normal"
            {...register("message", { required: "Message is required" })}
            error={!!errors.message}
            helperText={errors.message?.message}
          />
          <Box display="flex" justifyContent="center" mt={2}>
            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Send Message"}
            </Button>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default SendSMS;
